/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';

loadStyles([{"rawString":".ms-DropdownBasicExample{max-width:300px}"}]);
/* tslint:enable */